import styled from 'styled-components';

import { Button } from '@xing-com/crate-lebenslauf-button';
import { Label } from '@xing-com/label';
import { RadioButtonGroup } from '@xing-com/radio-button-group';
import { InputArea } from '@xing-com/text-field';
import {
  spaceM,
  spaceL,
  spaceXXL,
  scale070,
  scale140,
  xdlColorTextSecondary,
  xdlColorBackgroundTertiary,
  xdlColorBorder,
  xdlColorText,
} from '@xing-com/tokens';

export const StyledReasonLabel = styled(Label)`
  display: flex;
  gap: ${spaceM};
  color: ${xdlColorTextSecondary};
`;

export const StyledInputArea = styled(InputArea)`
  & textarea {
    min-height: 100px;
    background: ${xdlColorBackgroundTertiary};
    border-bottom: 2px solid ${xdlColorBorder};
    border-left-width: 0px;
    border-radius: 4px 0px;
    border-right-width: 0px;
    border-top-width: 0px;
    color: ${xdlColorText};
    display: inline-block;
    outline: none;
    padding: 10px 12px 10px 16px;
    overflow-y: hidden;
    resize: none;
    width: calc(100% - ${scale140});
    font-size: ${scale070};
    margin-left: ${scale140};
  }
`;

export const StyledButton = styled(Button)`
  margin-top: ${spaceXXL};
`;

export const StyledRadioButtonGroup = styled(RadioButtonGroup)`
  margin-top: ${spaceM};

  & > li {
    padding-left: 0;
  }
`;

export const StyledBackButton = styled(Button)`
  margin-top: ${spaceXXL};
  margin-right: ${spaceL};
`;
